interface Props {
  inscritos: number;
  limite: number;
}
export default function Progress({ inscritos, limite }: Props) {
  const PORCENTAGEM =
    inscritos === 0 ? 0 : ((inscritos / limite) * 100).toFixed(1);
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#f0f0f0",
        width: "100%",
        height: "6px",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          width: `${(inscritos / limite) * 100}%`,
          backgroundColor: "#00b0ff",
          height: "6px",
          borderRadius: "5px",
        }}
      />
      <span
        style={{
          position: "absolute",
          top: 10,
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: "10px",
          fontWeight: "bold",
          width: "100%",
          textAlign: "center",
        }}
      >
        {inscritos}/{limite} ({PORCENTAGEM}%)
      </span>
    </div>
  );
}
